import { RematchDispatch, RematchRootState } from '@rematch/core';
import { connect } from 'react-redux';
import { RootModel } from '../../../../state';
import { IModelSelectionContainer } from './IModelSelectionContainer';

export const mapState = (state: RematchRootState<RootModel>) => ({
  projectId: state.projects.project.id,
  selected: state.imodels.iModel.iModelId,
});

export const mapDispatch = (dispatch: RematchDispatch<RootModel>) => ({
  setIModelId: (iModelId: string) => dispatch.imodels.setIModelId(iModelId),
});

export const ConnectedIModelSelection = connect(
  mapState,
  mapDispatch
)(IModelSelectionContainer);
